export const useUserHooks = ( props ) => {
  const { user } = props;

  const verifyPermission = ( permission ) => {
    return user?.accessLevel?.findIndex(x => x === permission) >= 0
  }

  const getPermissionForApproval = ( rule) => {
    if( verifyPermission('1') ) {
      return true
    }
    if(rule.approver === "group" || rule.approverType === 'group' ) {
      const alreadyApprovers = rule.approvers || [];
      const isApproved = alreadyApprovers.findIndex(x => x.userId === user.userId) >= 0
      if (isApproved) {
        return false
      } else {
        return user.userGroups.findIndex(x => x === rule.approverUser) >= 0
      }
    } else {
      return rule.approverUser === user.userId;
    }
  }

  return {
    verifyPermission,
    getPermissionForApproval,
  }
}
